<template>
  <div class="consolidate_consum_holder">
    <div class="parcel_info_text">
      Parcela <span class="parcel_info_text_dark">{{ parcel_name }}</span> ({{ parcel_surface }} ha) cu un cost total de
      <span class="parcel_info_text_dark">{{ totalCost }}</span> Ron insemnând
      <span class="parcel_info_text_dark">{{ totalCostPerHa }}</span> Ron/ha.
      <span v-if="costPerKg !== null" class="parcel_info_text_dark">Cost/kg: {{ costPerKg }} Ron/kg</span>
    </div>
    <div class="consum_title_holder">
      <div class="consum_title">Produse</div>
      <div class="filter_icon_holder">
        <b-button class="rent_filter_icon" variant="outline-secondary" size="sm" pill @click="showConsumFilter"
          ><img src="@/assets/images/icons/options.svg"
        /></b-button>
      </div>
    </div>
    <DxScrollView
      ref="scrollView"
      :elementAttr="scrollListAttributes"
      :use-native="true"
      @reach-bottom="reachBottom"
      @scroll="scroll"
      reachBottomText="Se încarcă..."
    >
      <div>
        <div class="no_dataLabel" v-if="noListData">Nu există consum</div>
        <div v-for="(data, d_idx) in consum_list_data" :key="data.data_idx_uuid">
          <div class="product_date">{{ data.date }}</div>
          <div class="con_consum_list_holder">
            <div v-for="(product, p_idx) in data.products" :key="product.idx_uuid">
              <div class="product_item">
                <div class="product_main_icon">
                  <div class="product_main_icon_file">
                    <img src="@/assets/images/icons/droplet.svg" />
                  </div>
                </div>
                <div class="product_main_info">
                  <div class="product_name">{{ product.name }}</div>
                  <div class="source_holder">
                    <div class="source">{{ getSource(product.source) }}</div>
                  </div>
                </div>
                <div class="dose_info">{{ product.dose }} {{ product.mu }}/ha</div>
                <div class="expand_icon_holder">
                  <div :class="product.expanded ? 'expand_icon_expanded' : 'expand_icon'" @click="expandProduct(product, d_idx, p_idx)">
                    <img v-if="product.expanded" src="@/assets/images/icons/arrow_up_green.svg" />
                    <img v-else src="@/assets/images/icons/arrow_down.svg" />
                  </div>
                </div>
              </div>
              <consum-details :templateData="product" v-show="product.expanded"></consum-details>
            </div>
          </div>
        </div>
      </div>
    </DxScrollView>
    <consum-filter :show-popup="consumFilterVisibility" @hidden="hideConsumFilter" @applyFilter="applyFilter"></consum-filter>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { DxScrollView } from "devextreme-vue/scroll-view";
import { v4 } from "uuid";
import ConsumDetails from "./consumDetails.vue";
import ConsumFilter from "./consumFilter.vue";

export default {
  name: "ConsolidateConsum",
  props: {
    parcel_uuid: {
      type: String,
      default: "",
    },
    parcel_name: String,
    parcel_group_parcel_uuids: {
      type: Array,
      default: () => [],
    },
    parcel_surface: String,
    total_weight_kg: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      scrollListAttributes: {
        class: "con_consum_list_scroller",
      },
      pagination: {},
      scrollOffset_top: 0,
      consum_list_data: {},
      noListData: false,
      consumFilterVisibility: false,
      consumType: "consolidate",
      totalCost: "0.00",
      totalCostPerHa: "0.00",
      costPerKg: null,
    };
  },
  components: {
    DxScrollView,
    ConsumDetails,
    ConsumFilter,
  },
  watch: {
    parcel_uuid(newVal, oldVal) {
      this.fillConsum(1, null, this.fillCallback);
      this.loadCostStratificationLayers();
    },
    consumType() {
      this.fillConsum(1, null, this.fillCallback);
    },
    parcel_group_parcel_uuids(newVal, oldVal) {
      this.fillConsum(1, null, this.fillCallback);
      this.loadCostStratificationLayers();
    },
  },
  methods: {
    ...mapActions({
      getParcelConsum: "smTransactions/getParcelConsum",
      //getParcelConsumSummary: "smTransactions/getParcelConsumSummary",
      getLayerCostStratificationAction: 'layers/getLayerCostStratification'
    }),
    getSource(source) {
      if (source == "digital_agenda") {
        return "Agenda digitală";
      } else if (source == "stock") {
        return "Stoc";
      } else {
        return source;
      }
    },
    loadCostStratificationLayers() {
       const parcelFilterValue =
        this.parcel_group_parcel_uuids && this.parcel_group_parcel_uuids.length > 0
          ? this.parcel_group_parcel_uuids.join()
          : this.parcel_uuid;

      if (!parcelFilterValue) {
        this.totalCost = "0.00";
        this.totalCostPerHa = "0.00";
        this.costPerKg = null;
        return;
      }

      this.getLayerCostStratificationAction({
        parcel_uuid: [parcelFilterValue],
        attach_query: "cost_per_kg",
      }).then((response) => {
        if (response && response.length > 0) {
          const costLayer = response.find(layer => layer.parcel_uuid === parcelFilterValue);
          if (costLayer) {
            this.totalCost = costLayer.total_cost && costLayer.total_cost != null ? this.formatNumber(this.toNumber(costLayer.total_cost)) : 0;
            this.totalCostPerHa = costLayer.cost_per_ha && costLayer.cost_per_ha != null ? this.formatNumber(this.toNumber(costLayer.cost_per_ha)) : 0;
            this.costPerKg = costLayer.cost_per_kg && costLayer.cost_per_kg != null ? this.formatNumber(this.toNumber(costLayer.cost_per_kg)) : null;
          }
        }
      }).catch(() => {
        // Handle error if needed
      });
    },
    fillConsum(page_number, filter = null, callback = null) {
      filter = filter ?? {};
      filter.page = page_number;

      const parcelFilterValue =
        this.parcel_group_parcel_uuids && this.parcel_group_parcel_uuids.length > 0
          ? this.parcel_group_parcel_uuids.join()
          : this.parcel_uuid;

      if (!parcelFilterValue) {
        this.totalCost = "0.00";
        this.totalCostPerHa = "0.00";
        this.consum_list_data = [];
        this.noListData = true;
        return;
      }

      if (page_number == 1) {
        this.$refs["scrollView"].instance.release(false);
      }

      /*this.getParcelConsumSummary({
        parcel_uuid: parcelFilterValue,
        type: this.consumType,
      }).then((response) => {
        const total = this.toNumber(response);
        this.totalCost = this.formatNumber(total);
        this.recalculateTotalCostPerHa();
      }).catch(() => {
        this.totalCost = "0.00";
        this.recalculateTotalCostPerHa();
      });*/

      this.getParcelConsum({
        parcel_uuid: parcelFilterValue,
        type: this.consumType,
        page: page_number,
      }).then((response) => {
        if (page_number == 1) {
          this.consum_list_data = [];
          this.$set(this.consum_list_data, []);
        }
        response.data.forEach((d) => {
          d.data_idx_uuid = v4();
          d.products.forEach((p) => {
            p.idx_uuid = v4();
            p.expanded = false;
          });
          this.consum_list_data.push(d);
          this.$set(this.consum_list_data, this.consum_list_data.length - 1, d);
        });

        this.pagination = response.pagination;
        this.noListData = this.consum_list_data.length == 0;
        if (callback != null) {
          callback();
        }
      }).catch(() => {
        this.noListData = this.consum_list_data.length == 0;
      });
    },
    toNumber(value) {
      if (typeof value === "number") {
        return Number.isFinite(value) ? value : 0;
      }

      if (typeof value === "string") {
        const normalized = value.replace(/,/g, "").trim();
        const parsed = Number.parseFloat(normalized);
        return Number.isFinite(parsed) ? parsed : 0;
      }

      return 0;
    },
    formatNumber(value) {
      return this.toNumber(value).toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
    recalculateTotalCostPerHa() {
      const total = this.toNumber(this.totalCost);
      const surface = this.toNumber(this.parcel_surface);

      if (surface > 0) {
        this.totalCostPerHa = this.formatNumber(total / surface);
      } else {
        this.totalCostPerHa = "0.00";
      }
    },
    fillCallback() {
      if (this.pagination.current_page == this.pagination.last_page || this.consum_list_data.length == 0) {
        this.$refs["scrollView"].instance.release(true);
      } else {
        this.$refs["scrollView"].instance.release(false);
      }
      this.$refs["scrollView"].instance.update();
      if (this.pagination.current_page == 1) {
        this.$refs["scrollView"].instance.scrollTo(0);
      }
    },
    reachBottom() {
      if (this.pagination.current_page < this.pagination.last_page) {
        this.fillConsum(this.pagination.current_page + 1, null, this.fillCallback);
      }
    },
    scroll(event) {
      this.scrollOffset_top = event.scrollOffset.top;
    },
    expandProduct(product, d_idx, p_idx) {
      product.expanded = !product.expanded;
    },
    showConsumFilter() {
      this.consumFilterVisibility = true;
    },
    hideConsumFilter() {
      this.consumFilterVisibility = false;
    },
    applyFilter(currentType) {
      this.consumType = currentType.code;
    },
  },
  mounted() {
    this.fillConsum(1, null, this.fillCallback);
    this.loadCostStratificationLayers();
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/components/consolidateConsum.scss";
</style>
